import {
  GET_PROVIDERS_REQUEST,
  GET_PROVIDERS_RESPONSE,
  ADD_PROVIDER_REQUEST,
  EDIT_PROVIDER_REQUEST,
  GET_PROVIDER_DETAILS_REQUEST,
  GET_PROVIDER_DETAILS_RESPONSE,
  DELETE_PROVIDER_REQUEST,
  GET_GENERATED_PASSWORD_REQUEST,
  GET_GENERATED_PASSWORD_RESPONSE,
  GET_REQUEST_STATUS
} from "./types";

// list
export const getProvidersRequest = (payload) => ({
  type: GET_PROVIDERS_REQUEST,
  payload,
});

export const getProvidersResponse = (payload) => ({
  type: GET_PROVIDERS_RESPONSE,
  payload,
});

// add
export const addProviderRequest = (payload) => ({
  type: ADD_PROVIDER_REQUEST,
  payload,
});

// edit
export const editProviderRequest = (payload) => ({
  type: EDIT_PROVIDER_REQUEST,
  payload,
});

// get by id (view)
export const getProviderDetailsRequest = (payload) => ({
  type: GET_PROVIDER_DETAILS_REQUEST,
  payload,
});

export const getProviderDetailsResponse = (payload) => ({
  type: GET_PROVIDER_DETAILS_RESPONSE,
  payload,
});

// Generated password
export const getGeneratedPasswordRequest = (payload) => ({
  type: GET_GENERATED_PASSWORD_REQUEST,
  payload,
});

export const getGeneratedPasswordResponse = (payload) => ({
  type: GET_GENERATED_PASSWORD_RESPONSE,
  payload,
});

export const deleteProviderRequest = (payload) => ({
  type: DELETE_PROVIDER_REQUEST,
  payload,
});

export const getRequestStatus = (payload) => ({
  type: GET_REQUEST_STATUS,
  payload,
});
